export default {
  getAllUserClaims: (userAddress: string) => `/tokens/user_claim/${userAddress}/`,
  getDataForClaims: (address:string, userAddress: string) => `/tokens/${address}/claim/${userAddress}/`,
  getRandomTokenIds: (address: string) => `/tokens/${address}/random_token/`,
  getTokensMetadata: (address: string, tokensIds: Array<string>) => `/tokens/${address}/list/?ids=${tokensIds}`,
};
